import { render } from "./CustomerAreas.vue?vue&type=template&id=567c4cea&scoped=true"
import script from "./CustomerAreas.vue?vue&type=script&scoped=true&lang=js"
export * from "./CustomerAreas.vue?vue&type=script&scoped=true&lang=js"

import "./CustomerAreas.vue?vue&type=style&index=0&id=567c4cea&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567c4cea"]])

export default __exports__